import { createContext } from 'react';

import { RedirectMap } from './types/redirect-map';
import { RewriteMap } from './types/rewrite-map';

export const context = createContext<{
  redirects: RedirectMap;
  rewrites: RewriteMap;
}>(undefined as any);
